import React, { forwardRef, ReactNode } from 'react';

interface InfiniteScrollProps {
    className?: string;
    last?: boolean;
    size?: string;
    children: ReactNode;
}

const InfiniteScroll = forwardRef<HTMLHeadingElement, InfiniteScrollProps>(
    ({ className, last, size, children }, ref) => {
        const classes: string[] = [];

        if (size) classes.push(size);
        if (className) classes.push(className);

        return (
            <div className={`sm-infinite-scroll ${classes.join(' ')}`}>
                {children}
                {last && (
                    <h1 ref={ref} className="loading-more">
                        <i className="far fa-spinner fa-spin" />
                    </h1>
                )}
            </div>
        );
    }
);

InfiniteScroll.displayName = 'InfiniteScroll';

export default InfiniteScroll;
